import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import HeaderLocation from '../components/Header';
import { getRandomDrink } from '../helpers';

export default function ExploreDrinks() {
  const [randomDrink, setRandomDrink] = useState();
  const handleGetDrink = async () => {
    const result = await getRandomDrink();
    if (result && result.drinks && result.drinks.length > 0) {
      setRandomDrink(result.drinks[0].idDrink);
    }
  };

  useEffect(() => {
    handleGetDrink();
  }, []);

  return (
    <div className="page-wrapper-custom">
      <HeaderLocation title="Explorar Bebidas" />
      <Container>
        <div className="text-center my-4">
          <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '2rem', color: 'var(--color-text)' }}>
            🍸 Coquetéis e Bebidas
          </h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '1rem', maxWidth: '500px', margin: '0 auto' }}>
            Explore coquetéis clássicos e invenções modernas para cada momento.
          </p>
        </div>

        <div className="d-flex flex-column gap-3 my-4 mx-auto" style={{ maxWidth: '650px' }}>
          <Link
            data-testid="explore-by-ingredient"
            to="/explorar/bebidas/ingredientes"
            className="recipe-link"
            style={{ textDecoration: 'none' }}
          >
            <div
              className="search-bar-card p-4 d-flex align-items-center justify-content-between"
              style={{
                transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                cursor: 'pointer',
                borderLeft: '5px solid var(--color-secondary)'
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <span style={{ fontSize: '2.4rem' }}>🍋</span>
                <div>
                  <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1.3rem', margin: 0, color: 'var(--color-text)' }}>
                    Por Ingredientes
                  </h3>
                  <p style={{ color: 'var(--color-text-muted)', fontSize: '0.9rem', margin: '4px 0 0 0' }}>
                    Encontre bebidas que utilizam os destilados, frutas ou licores da sua preferência.
                  </p>
                </div>
              </div>
              <span style={{ color: 'var(--color-secondary)', fontWeight: 700, fontSize: '1.2rem' }}>&rarr;</span>
            </div>
          </Link>

          <Link
            data-testid="explore-surprise"
            to={ `/bebidas/${randomDrink}` }
            onClick={ handleGetDrink }
            className="recipe-link"
            style={{ textDecoration: 'none' }}
          >
            <div
              className="search-bar-card p-4 d-flex align-items-center justify-content-between"
              style={{
                transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                cursor: 'pointer',
                borderLeft: '5px solid var(--color-primary)'
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <span style={{ fontSize: '2.4rem' }}>✨</span>
                <div>
                  <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1.3rem', margin: 0, color: 'var(--color-text)' }}>
                    Me Surpreenda!
                  </h3>
                  <p style={{ color: 'var(--color-text-muted)', fontSize: '0.9rem', margin: '4px 0 0 0' }}>
                    Sorteie um coquetel especial ou drink sem álcool selecionado pelo nosso bartender virtual.
                  </p>
                </div>
              </div>
              <span style={{ color: 'var(--color-primary-dark)', fontWeight: 700, fontSize: '1.2rem' }}>&rarr;</span>
            </div>
          </Link>
        </div>
      </Container>
      <Footer className="footer white" />
    </div>
  );
}
